@if (metricsData.length) {
    <mat-card class="cardWithShadow">
    <mat-card-content class="p-24">
        <!-- Summary KPIs -->
        <div class="d-flex justify-content-between flex-wrap gap-16">
            @for (key of ['totalRouted', 'totalResponded', 'totalErrors', 'avgResponse']; track key) {
                <mat-card class="kpi-card">
                    <mat-card-header>
                        <mat-card-title>
                            {{
                                key === 'totalRouted' ? summary.totalRouted :
                                    key === 'totalResponded' ? summary.totalResponded :
                                        key === 'totalErrors' ? summary.totalErrors :
                                            key === 'avgResponse' ? summary.avgResponse + ' s' : ''
                            }}
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        {{
                            key === 'totalRouted' ? 'Messages Routed' :
                                key === 'totalResponded' ? 'Responses' :
                                    key === 'totalErrors' ? 'Errors' :
                                        key === 'avgResponse' ? 'Avg Response' : ''
                        }}
                    </mat-card-content>
                </mat-card>
            }
        </div>
        <div class="d-flex flex-wrap gap-24" style="margin-top: 24px;">
            <!-- Timeline Chart -->
            <mat-card class="chart-card" style="flex: 1 1 300px;">
                <mat-card-header>
                    <mat-card-title>Avg Response Time Over Time</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <apx-chart
                            [series]="timelineSeries"
                            [chart]="timelineChart"
                            [xaxis]="timelineXAxis"
                            [stroke]="timelineStroke"
                            [tooltip]="timelineTooltip">
                    </apx-chart>
                </mat-card-content>
            </mat-card>
            <!-- Issues Donut Chart -->
            <mat-card class="chart-card" style="flex: 1 1 300px;">
                <mat-card-header>
                    <mat-card-title>Response Issues</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <apx-chart
                            [series]="issuesSeries"
                            [chart]="issuesChart"
                            [labels]="issuesLabels"
                            [tooltip]="issuesTooltip">
                    </apx-chart>
                </mat-card-content>
            </mat-card>
        </div>
        <!-- Usage Stacked Bar Chart -->
        <mat-card class="chart-card" style="margin-top: 24px;">
            <mat-card-header>
                <mat-card-title>Daily Usage</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <apx-chart
                        [series]="usageSeries"
                        [chart]="usageChart"
                        [plotOptions]="usagePlotOptions"
                        [dataLabels]="usageDataLabels"
                        [legend]="usageLegend"
                        [xaxis]="usageXAxis"
                        [responsive]="usageResponsive">
                </apx-chart>
            </mat-card-content>
        </mat-card>
    </mat-card-content>
    </mat-card>
}
